import React from 'react';
import { Group, LoadingOverlay, Table, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IFormattedMatch, IOrgJob, ISourceMatch, ISubmitMatchesResponse } from '../PropagateMatchesTypes';
import MatchDescriptor from './MatchDescriptor';
import MatchRow from './MatchRow';
import TableHeaders from './TableHeaders';

type Props = {
  activeTab: string;
  fetchSurveyJobMatchData: (params: {
    resetSelectedMatches?: boolean;
    surveyJobMatch?: ISourceMatch;
   matchesMade?: ISubmitMatchesResponse;
  }) => void;
  orgJobs: IOrgJob[];
  setSurveyJobMatches: React.Dispatch<React.SetStateAction<ISourceMatch[]>>;
  surveyJobMatch: ISourceMatch;
  surveyJobMatches: ISourceMatch[];
  toggledTargetMatches: string[];
  updateToggledMatches: (id: string) => void;
};

const Matches: React.FC<Props> = ({
  activeTab,
  fetchSurveyJobMatchData,
  orgJobs,
  setSurveyJobMatches,
  surveyJobMatch,
  surveyJobMatches,
  toggledTargetMatches,
  updateToggledMatches,
}) => {
  const [visible, { open, close }] = useDisclosure(false);
  const hasMatches = surveyJobMatch?.propagateMatches && surveyJobMatch.propagateMatches.length > 0;

  const updateSurveyJobMatch = (
    surveyJobMatch: ISourceMatch,
    updates: Partial<ISourceMatch>
  ): ISourceMatch[] => {
    return surveyJobMatches.map(match =>
      match.sourceMatchId === surveyJobMatch.sourceMatchId
        ? { ...surveyJobMatch, ...updates }
        : match
    );
  };

  return (
    <>
      <LoadingOverlay visible={visible} zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />
      <MatchDescriptor
        activeTab={activeTab}
        closeLoader={close}
        fetchSurveyJobMatchData={fetchSurveyJobMatchData}
        index={surveyJobMatches.indexOf(surveyJobMatch)}
        openLoader={open}
        orgJobs={orgJobs}
        setSurveyJobMatches={setSurveyJobMatches}
        surveyJobMatch={surveyJobMatch}
        surveyJobMatches={surveyJobMatches}
        updateSurveyJobMatch={updateSurveyJobMatch}
      />
      {!hasMatches ? (
        <Group justify="center">
          <Title p="20" fw={700} size="h5">
            There are no propagate options available for this match.
          </Title>
        </Group>
      ) : (
        <Table>
          <TableHeaders
            activeTab={activeTab}
            fetchSurveyJobMatchData={fetchSurveyJobMatchData}
            orgJobs={orgJobs}
            setSurveyJobMatches={setSurveyJobMatches}
            surveyJobMatch={surveyJobMatch}
            surveyJobMatches={surveyJobMatches}
            updateSurveyJobMatch={updateSurveyJobMatch}
            openLoader={open}
            closeLoader={close}
          />
          <Table.Tbody>
            {surveyJobMatch.propagateMatches.map((propagateMatch: IFormattedMatch) => (
              <MatchRow
                key={`${propagateMatch.targetJobId}-${propagateMatch.surveyCode}-${propagateMatch.surveyJobCode}`}
                propagateMatch={propagateMatch}
                setSurveyJobMatches={setSurveyJobMatches}
                surveyJobMatch={surveyJobMatch}
                toggledTargetMatches={toggledTargetMatches}
                updateToggledMatches={updateToggledMatches}
              />
            ))}
          </Table.Tbody>
        </Table>
      )}
    </>
  );
};

export default Matches;
